export const MemberTrainOrderEn = {
    xunjiadang:'Training order',
    peixunfuwu:'Please enter service name or order number keyword',
    jiage:'search',
    zhuantai:'status',
    caozuo:'operation',
    pingjiazhuantai:'price',
    dingdangneirong:'Order content'
}


// WEBPACK FOOTER //
// ./src/lang/member/MemberTrainOrder/MemberTrainOrderEn.js